import React, { useState, useEffect } from 'react';
import moment from 'moment';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  IconButton,
  TextField,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core/styles';
import Button from './Button';
import DateSelect from './DateSelect';

import * as api from '../services/api/admin';

function BlogEditModal(props) {
  const {
    openEditModal,
    onClose,
    onDelete,
    classes: { modal, modalContent, input },
  } = props;

  const [id, setId] = useState('');
  const [title, setTitle] = useState('');
  const [author, setAuthor] = useState('');
  const [headline, setHeadline] = useState('');
  const [category, setCategory] = useState('');
  const [content, setContent] = useState('');
  const [date, setDate] = useState('');
  const [linkToImg, setLinkToImg] = useState('');
  const [imgDescription, setImgDescrption] = useState('');
  const [externalUrl, setExternalUrl] = useState('')

  useEffect(() => {
    (async () => {
      if (!!openEditModal) {
        const blog = await api.fetchBlogContentById(openEditModal);
        setId(blog.id);
        setTitle(blog.title);
        setAuthor(blog.author);
        setHeadline(blog.headline);
        setContent(blog.content);
        setCategory(blog.category);
        setDate(blog.date);
        setLinkToImg(blog.linkToImg);
        setContent(blog.content);
        setImgDescrption(blog.imgDescription);
        setExternalUrl(blog.externalUrl)
      }
    })();
  }, [openEditModal]);

  const onUpdate = async obj => {
    try {
      await api.updateBlogContent({
        id: openEditModal,
        title,
        author,
        headline,
        content,
        category,
        date,
        linkToImg,
        content,
        imgDescription,
        externalUrl
      });
    } catch (err) {
      console.log(err);
    } finally {
      onClose();
    }
  };

  return (
    <Dialog fullWidth open={openEditModal} onClose={onClose} classes={{ paper: modal }}>
      <DialogTitle>
        <Grid container alignItems="center">
          <Grid item xs={11}>
            <h2>Edit content</h2>
          </Grid>
          <Grid item xs={1}>
            <IconButton aria-label="Close" onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </Grid>
        </Grid>
      </DialogTitle>
      <DialogContent classes={{ root: modalContent }}>
        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="title"
          value={title}
          className={input}
          onChange={event => setTitle(event.target.value)}
          InputProps={{ whiteSpace: 'pre-line' }}
          helperText="Title"
        />

        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="author"
          value={author}
          className={input}
          onChange={event => setAuthor(event.target.value)}
          InputProps={{ whiteSpace: 'pre-line' }}
          helperText="Author"
        />

        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="headline"
          value={headline}
          className={input}
          onChange={event => setHeadline(event.target.value)}
          InputProps={{ whiteSpace: 'pre-line' }}
          multiline
          rows="2"
          helperText="Headline"
        />
        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="category"
          value={category}
          className={input}
          onChange={event => setCategory(event.target.value)}
          InputProps={{ whiteSpace: 'pre-line' }}
          helperText="Category"
        />

        <DateSelect
          label="Date Published"
          disableFuture
          fullWidth
          format="MM/DD/YYYY"
          placeholder="Date originally publihed MM/DD/YYYY ex. 01/01/2001"
          variant="outlined"
          value={new Date(date)}
          onChange={date => setDate(moment.utc(date).format('MM/DD/YYYY'))}
        />
        <TextField
          variant="outlined"
          fullWidth
          name="linkToImg"
          value={linkToImg}
          className={input}
          onChange={event => setLinkToImg(event.target.value)}
          multiline
          rows="1"
          helperText="Link for image. URL goes here."
        />
        <TextField
          whitespace="pre-wrap"
          variant="outlined"
          fullWidth
          name="content"
          value={content}
          className={input}
          onChange={event => setContent(event.target.value)}
          multiline
          InputProps={{ whiteSpace: 'pre-line' }}
          rows="4"
          helperText="Content goes here"
        />
        <TextField
          variant="outlined"
          fullWidth
          name="imgDescription"
          value={imgDescription}
          className={input}
          onChange={event => setImgDescrption(event.target.value)}
          multiline
          rows="1"
          helperText="Image Description. Write a short description."
        />

        <TextField
          variant="outlined"
          fullWidth
          name="externalUrl"
          value={externalUrl}
          className={input}
          onChange={event => setExternalUrl(event.target.value)}
          multiline
          rows="1"
          helperText="Optional field if there is video. Make sure you are getting the embedded link! They are often under *share*... https://www.youtube.com/embed/DwjMCtjxtTg"
        />

        <Button
          onClickSuccessSnackbar="Content deleted sucessfully."
          onClickFailSnackbar="Content was not deleted."
          color="secondary"
          onClick={() => onDelete(id)}
        >
          Delete
        </Button>
      </DialogContent>

      <Button
        onClickSuccessSnackbar="You have successfully updated the content."
        onClickFailSnackbar="Content could not be updated."
        color="primary"
        variant="contained"
        justify="center"
        onClick={onUpdate}
      >
        Update
      </Button>
    </Dialog>
  );
}

const styles = () => ({
  modal: { maxWidth: '1000px' },
  modalContent: {
    overflow: 'visible',
  },
  input: {
    margin: '0.5em 0',
  },
});

export default withStyles(styles)(BlogEditModal);
